<template>
  <el-dialog v-model="state.visible" title="開始結帳" :width="isMobile ? '100vw' : '767px'" :top="'0px'"
    modal-class="checkout-form-dialog" :before-close="handleClickClose" :close-on-click-modal="false"
    :close-on-press-escape="false" destroy-on-close append-to-body>
    <template v-if="!!form.carts.length" #footer>
      <div class="checkout-footer-wrapper">
        <template v-if="state.isCartEditing">
          <div class="checkout-footer" :style="{ height: '70px' }">
            <div class="mx-0 px-4">
              <el-button type="primary" size="large" class="btn-block large-button" @click="setCartEdited">
                <i class="fa fa-hand-pointer-o mr-2" aria-hidden="true"></i>
                {{ state.fromBuyNow ? $t("下一步") : $t("完成編輯") }}
              </el-button>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="checkout-footer" :style="{ height: hiddenPrice ? '60px' : '105px' }">
            <div v-if="!hiddenPrice" class="flex gap-2 justify-content-between">
              <div class="pb-0">
                <span class="h5 font-bold text-gray-600 mr-1">
                  {{ $t("總金額") }}
                </span>
                <span class="text-sm text-gray-400"> {{ $t("費用") }}</span>
                <a href="javascript:void(0)" class="block text-sm text-accent" @click="viewCartEventItems">
                  <span>{{ $t("查看價格明細") }}</span>
                </a>
              </div>
              <div class="text-right font-extrabold h4">
                {{ `${state.currency_symbol} ${currencyFormat(cartTotal)}` }}
              </div>
            </div>
            <div class="mx-0 mt-2">
              <el-button type="primary" size="large" class="btn-block large-button" @click="executeSubmit(ruleFormRef)">
                <i class="fa fa-hand-pointer-o mr-2" aria-hidden="true"></i>
                {{ aliasTranslations?.checkout || t("carts.checkout") }}
              </el-button>
            </div>
          </div>
        </template>
      </div>
    </template>
    <div class="w-full bg-slate-50 pt-2 pb-4">
      <div :class="['checkout', 'w-full']">
        <div v-if="!form.carts.length" class="no-prod-msg w-full">
          <EmptyCartImage />
        </div>
        <div v-else class="w-full">
          <el-form ref="ruleFormRef" :model="form" :rules="rules" label-position="top" label-width="120px">
            <div class="col-12 no-padding-xs py-0">
              <template v-if="!state.isCartEditing">
                <PaymentInfo v-model="form" :available-payment-types="availablePaymentTypes" />
                <LogisticInfo v-model="form" :available-logistic-types="availableLogisticTypes" />
                <BuyerInfo v-model="form" />

                <ToInfo v-model="form">
                  <div v-if="!!usedLogisticTypes.length">
                    <ToHome ref="homeRef" v-model="form" v-model:state="state" :used-logistic-types="usedLogisticTypes"
                      :provice-map="proviceMap" show-uads @update:state:isOuterIsland="updateStateIsOuterIsland" />
                    <ToCvs711 ref="cvsPcscRef" v-model="form" v-model:state="state"
                      :used-logistic-types="usedLogisticTypes" @update:state:isOuterIsland="updateStateIsOuterIsland"
                      show-uads />
                    <ToCvsFamily ref="cvsFamilyRef" v-model="form" v-model:state="state"
                      :used-logistic-types="usedLogisticTypes" @update:state:isOuterIsland="updateStateIsOuterIsland"
                      show-uads />
                    <ToCvsHilife ref="cvsHilifeRef" v-model="form" v-model:state="state"
                      :used-logistic-types="usedLogisticTypes" @update:state:isOuterIsland="updateStateIsOuterIsland"
                      show-uads />
                    <ToCvsOkmart ref="cvsOkmartRef" v-model="form" v-model:state="state"
                      :used-logistic-types="usedLogisticTypes" @update:state:isOuterIsland="updateStateIsOuterIsland"
                      show-uads />
                  </div>
                  <div v-else>
                    <el-result icon="error" title="您選擇的【付款方式】或【配送方式】不適用您購物車中的商品。" style="padding: 1rem">
                      <template slot="extra">
                        <el-button type="primary" @click="viewCartEventItems">
                          {{ $t("查看商品") }}
                        </el-button>
                      </template>
                    </el-result>
                  </div>
                </ToInfo>

                <!-- <InsuranceFeesCheck v-if="data.enable_insurance_fees && !!insuranceFees" :modelForm="form"
                :modelState="state" :insurance-assort-raw-total="insuranceAssortRawTotal"
                :insurance-fees="insuranceFees" /> -->

                <InvoiceInfo v-if="showInvoice" v-model="form" :state="state" :provice-map="proviceMap"
                  :used-logistic-types="usedLogisticTypes" :enableEInvoice="enableEInvoice" @change="handleSameHome" />

                <div class="sector memo-sector">
                  <div class="row">
                    <div class="col-12 sector__header text-accent">
                      {{ $t("orders.memo") }}
                      ({{ $t("carts.optional") }})
                    </div>
                    <div class="col-12 sector__content">
                      <div class="row">
                        <div class="col-12">
                          <el-input v-model="form.memo" maxlength="100" show-word-limit type="textarea" size="large"
                            :autosize="{ minRows: 3 }" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <template v-if="loginUserId && !state.isCartEditing && !hiddenPrice">
                <DiscountCode v-if="!hasPromGift" v-model="form" :state="state" :promotion-map="promotionMap"
                  @ok="handleDiscountCode" />
                <ShopCoinDiscount v-if="!!data.account_shop_coin && data.account_shop_coin > 0 && !hasPromGift
                  " v-model="form" :data="data" :coin-discount-limit="coinDiscountLimit" />
              </template>
              <CartEventItems v-model="form" :state="state" :data="data"
                :cart-event-groups-formatted="cartEventGroupsFormatted" :store-data="storeData"
                @update:state="updateState" @update:data="updateData" @update:form="updateForm" @delete="deleteCart"
                @change="changeQty" @change-assort="handleChangeAssort" />
              <template v-if="!state.isCartEditing">
                <CartBillTotal v-model="form" :state="state" :data="data" :store-data="storeData"
                  :cart-groups-formatted="cartGroupsFormatted" :cart-event-groups-formatted="cartEventGroupsFormatted"
                  :coin-discount-limit="coinDiscountLimit" :delivery-fees="deliveryFees"
                  :delivery-fees-discount="deliveryFeesDiscount" />
              </template>
              <!-- <CartAddOns v-if="state.isCartEditing" :modelState="state" :modelData="data" :modelForm="form"
              :cart-event-groups-formatted="cartEventGroupsFormatted" @update:state="updateState"
              @update:data="updateData" @delete="deleteCart" @change="changeQty" /> -->
            </div>
          </el-form>
        </div>
        <!-- <pre class="text-xs">{{ JSON.stringify(form, null, 4) }}</pre> -->
        <!-- <pre class="text-xs">{{ JSON.stringify(data, null, 4) }}</pre> -->
        <!-- <pre class="text-xs">{{ JSON.stringify(state, null, 4) }}</pre> -->
      </div>
    </div>
  </el-dialog>

  <ProductChooseAssortDialog :is-bundle="props.isBundle" />
</template>

<script setup>
import { reactive, ref, computed, watch, toRaw } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import {
  _api_updateCartQty,
  _api_deleteCart,
  _api_checkoutCart,
  _api_getCountryMap,
  _api_getCarts,
  _api_createCart,
  _api_createCartGroup,
} from "../../api/index.js";

import {
  notificationErrors,
  currencyFormat,
  assignCartCount,
  clearCartCount,
  dataTranslations,
  breakpoint,
  isBundlePromotionType,
  lookupAliasTranslations,
} from "../../utils";
import _ from "lodash";
import PaymentInfo from "./checkout/PaymentInfo.vue";
import LogisticInfo from "./checkout/LogisticInfo.vue";
import BuyerInfo from "./checkout/BuyerInfo.vue";
import ToInfo from "./checkout/ToInfo.vue";
import ToHome from "./checkout/ToHome.vue";
import ToCvs711 from "./checkout/ToCvs711.vue";
import ToCvsFamily from "./checkout/ToCvsFamily.vue";
import ToCvsHilife from "./checkout/ToCvsHilife.vue";
import ToCvsOkmart from "./checkout/ToCvsOkmart.vue";
// import InsuranceFeesCheck from "./checkout/InsuranceFeesCheck.vue";
import InvoiceInfo from "./checkout/InvoiceInfo.vue";
import DiscountCode from "./checkout/DiscountCode.vue";
import ShopCoinDiscount from "./checkout/ShopCoinDiscount.vue";
import CartEventItems from "./checkout/CartEventItems.vue";
import CartBillTotal from "./checkout/CartBillTotal.vue";
// import CartAddOns from "./checkout/CartAddOnsList.vue";
import ProductChooseAssortDialog from "./ProductChooseAssortDialog.vue";
import { ElLoading } from "element-plus";
import EmptyCartImage from "../EmptyCartImage.vue";

const props = defineProps({
  isBundle: Boolean,
})

const { t, n, locale } = useI18n();
const store = useStore();
const storeData = computed(() => store.getters["lite/storeData"]);
const cartData = computed(() => store.getters["lite/cartData"]);

const hiddenPrice = computed(() => !!storeData.value?.settings?.hidden_price);
const hiddenCart = computed(() => !!storeData.value?.settings?.hidden_cart);
const hiddenContact = computed(() => !!storeData.value?.settings?.hidden_contact);
const aliasTranslations = computed(() =>
  lookupAliasTranslations(storeData.value?.alias_translations, locale.value)
);

const isMobile = computed(() => breakpoint.value.xs || breakpoint.value.sm);

// 浮點數位數
// const formatFloat = (num, pos = 0) => {
//   const size = Math.pow(10, pos);
//   return Math.round(num * size) / size;
// };

const data = ref(null);
const homeRef = ref();
const cvsPcscRef = ref();
const cvsFamilyRef = ref();
const cvsHilifeRef = ref();
const cvsOkmartRef = ref();
const refreshPricingVersion = ref(+new Date());

const loginUserId = computed(() => store.getters["lite/userData"]?.id);

const hasPromGift = computed(() => {
  // 活動贈品不能使用購物金＆折扣碼
  const store_assort_ids = [];
  let hasPromGift = false;
  data.value?.promotions?.forEach((prom) => {
    for (const [k, v] of Object.entries(prom?.discountable_store_product_assorts_map)) {
      // console.debug(k, v)
      if (v?.activate_gift && v?.gift_items.length) {
        store_assort_ids.push(v?.store_assort_id);
      }
    }
  });
  // console.debug("hasPromGift: ", store_assort_ids)
  form.carts.forEach((cart) => {
    if (cart?.checked && store_assort_ids.includes(cart.store_assort_id)) {
      hasPromGift = true;
    }
    // console.debug("cart: ", cart.checked, cart.store_assort_id)
  });
  return hasPromGift;
});

const TEMPERATURE_I18N = computed(() => [
  t("products.temperature0"),
  t("products.temperature1"),
  t("products.temperature2"),
]);

const showInvoice = computed(() => data.value?.country === "TW");

const promotionMap = computed(() => _.keyBy(data.value?.promotions || [], "id"));

const logisticMap = computed(() => _.keyBy(data.value?.logistics || [], "delivery_type"));

// const paymentMap = computed(() => _.keyBy(data.value?.payments || [], "type"));

const hasGoogleGa = computed(() => data.value?.trackers?.ga_ids.length > 0);
// 組合原始總額
const assortRawTotal = computed(() =>
  form.carts.reduce(
    (total, curr) => (total += curr.checked ? curr.sale_price * curr.quantity : 0),
    0
  )
);
// 紅利折抵上限
const coinDiscountLimit = computed(() => {
  let limit =
    assortRawTotal.value +
    deliveryFees.value -
    deliveryFeesDiscount.value -
    assortDiscount.value -
    promDiscount.value -
    promotionCodeDiscount.value;
  return data.value.account_shop_coin > limit ? limit : data.value.account_shop_coin;
});

// 計算任選數量
const getBundleDiscount = (promotion, carts = []) => {
  let prom_discount = 0; // 活動折扣
  const condition = promotion?.conditions?.[0];
  let obj = {
    prom_discount: formatFloat(prom_discount, data.value.currency_point),
    choose_gifts: [],
    choose_gift_qty: 0,
  };
  if (!promotion || !condition || promotion?.condition_min_type != "qty") return obj;
  let bundles = [];
  let cartsCopy = _.cloneDeep(carts);
  // 1. 排序金額(大到小)
  const sortCart = [...cartsCopy.sort((a, b) => b.discounted_price - a.discounted_price)];

  // 2. 拆解單筆商品數量
  cartsCopy = [];
  sortCart.forEach((cart) => {
    if (cart.checked) {
      for (let i = 0; i < cart.quantity; i++) {
        cartsCopy.push({ ...cart, quantity: 1 });
      }
    }
  });
  // 3. 組合任選條件
  let assort_total = 0,
    discounted_price = 0,
    discount_amount = 0,
    discountable_quantity = 0;
  bundles = _.chunk(cartsCopy, condition?.min_qty);
  for (const bundle of bundles) {
    if (bundle.length != condition?.min_qty) continue;
    // console.debug("bundle", toRaw(bundle))
    bundle.forEach((cart) => {
      assort_total += cart.discounted_price;
    });
    discounted_price += condition?.discounted_price;
    discount_amount += condition?.discount_amount;
    discountable_quantity += condition?.discountable_quantity;
  }
  // console.debug("condition", toRaw(condition))
  const discount_type = promotion?.discount_type;
  let choose_gift_store_product_ids = [];
  if (discount_type == "pricing") {
    // 固定金額
    prom_discount += assort_total - discounted_price;
  } else if (discount_type == "amount") {
    prom_discount = discount_amount;
  } else if (discount_type == "percentage") {
    prom_discount = assort_total * (condition.discount_percentage / 100);
  } else if (discount_type == "gift") {
    choose_gift_store_product_ids = condition.discountable_store_product_ids;
    obj.choose_gift_qty = discountable_quantity;
  }
  const promDiscountableStoreProductMap = _.keyBy(
    promotion.discountable_store_products,
    "id"
  );
  choose_gift_store_product_ids.forEach((store_product_id) => {
    const gift = promDiscountableStoreProductMap[store_product_id.toString()];
    if (gift) {
      obj.choose_gifts.push(gift);
    }
  });
  obj.prom_discount = formatFloat(prom_discount, data.value.currency_point);
  return obj;
};

const getPromotionDiscount = (promotion, assort_total, assort_count) => {
  let prom_discount = 0; // 活動折扣
  if (!promotion) return prom_discount;

  let discount_type = promotion.discount_type;
  let discount_value = null;
  let choose_gift_store_product_ids = [];
  let choose_gift_qty = 0;

  // 滿額
  if (promotion.condition_min_type == "amount") {
    for (const condition of promotion.conditions.sort(
      (a, b) => b.min_amount - a.min_amount
    )) {
      if (assort_total >= condition.min_amount) {
        if (discount_type == "amount") {
          discount_value = condition.discount_amount;
        } else if (discount_type == "percentage") {
          discount_value = condition.discount_percentage;
        } else if (discount_type == "gift") {
          choose_gift_store_product_ids = condition.discountable_store_product_ids;
          choose_gift_qty = condition.discountable_quantity;
        }
        break;
      }
    }
  }
  // 滿件
  else if (promotion.condition_min_type == "qty") {
    for (const condition of promotion.conditions.sort((a, b) => b.min_qty - a.min_qty)) {
      if (assort_count >= condition.min_qty) {
        if (discount_type == "amount") {
          discount_value = condition.discount_amount;
        } else if (discount_type == "percentage") {
          discount_value = condition.discount_percentage;
        } else if (discount_type == "gift") {
          choose_gift_store_product_ids = condition.discountable_store_product_ids;
          choose_gift_qty = condition.discountable_quantity;
        }
        break;
      }
    }
  }

  if (discount_type && discount_value) {
    if (discount_type == "amount") {
      prom_discount = discount_value;
    } else if (discount_type == "percentage") {
      prom_discount = assort_total * (discount_value / 100);
    }
  }

  const promDiscountableStoreProductMap = _.keyBy(
    promotion.discountable_store_products,
    "id"
  );
  let choose_gifts = [];
  choose_gift_store_product_ids.forEach((store_product_id) => {
    const gift = promDiscountableStoreProductMap[store_product_id.toString()];
    if (gift) {
      choose_gifts.push(gift);
    }
  });

  return {
    prom_discount: formatFloat(prom_discount, data.value.currency_point),
    choose_gifts: choose_gifts,
    choose_gift_qty: choose_gift_qty,
  };
};
// 結帳總額
const cartTotal = computed(() => {
  // console.warn(`computed cartTotal ${new Date()}`);

  // 活動贈品不能使用購物金＆折扣碼
  let shopCoinDiscount = form.shop_coin_discount;
  if (hasPromGift.value) {
    shopCoinDiscount = 0;
  }

  let total =
    assortRawTotal.value +
    deliveryFees.value -
    deliveryFeesDiscount.value -
    shopCoinDiscount -
    assortDiscount.value -
    promDiscount.value -
    promotionCodeDiscount.value;

  // console.warn('assortRawTotal', assortRawTotal.value)
  // console.warn('deliveryFees', deliveryFees.value)
  // console.warn('deliveryFeesDiscount', deliveryFeesDiscount.value)
  // console.warn('assortDiscount', assortDiscount.value)
  // console.warn('promDiscount', promDiscount.value)
  // console.warn('promotionCodeDiscount', promotionCodeDiscount.value)

  return total;
});

const cartEventGroupsFormatted = computed(() => {
  // console.warn(`computed cartEventGroupsFormatted ${new Date()}`);
  if (!form.carts.length) {
    return {};
  }
  var start = 0;
  var end = 0;
  start = new Date().getTime();

  const grouped = _.groupBy(form.carts, (cart) => {
    return cart.event_group ? cart.event_group.event_group_uuid : null;
  });
  // console.log("by 活動: ", grouped)
  const formatted = _.reduce(
    grouped,
    (rst, val, key) => {
      // console.log("key:", key)
      // console.log("rst:", rst)
      const cartsCopy = _.cloneDeep(val);
      let cart = cartsCopy[0];
      let cart_group_name = t("carts.shoppingCart");

      let promotion = null;
      if (key && cart.event_group) {
        promotion = promotionMap.value?.[cart.event_group.event_id];
        if (promotion) {
          cart_group_name = promotion.title;
          if (
            promotion.min_amount_free_shipping &&
            promotion.min_amount_free_shipping !== null
          ) {
            cart_group_name += " (滿" + promotion.min_amount_free_shipping + "免運)";
          }
        } else {
          cart_group_name = "異常活動";
        }
      }

      let assort_count = 0; // 組合數量
      let assort_org_total = 0; // 組合 sale_price 總額
      let assort_org_total2 = 0; // 組合 comm_price 總額
      let assort_total = 0; // 組合 discounted_price 總額
      let assort_discount = 0; // 網紅折扣
      let assort_discount2 = 0; // 網紅折扣 (用 comm_price)
      let prom_discount = 0; // 活動折扣
      let discountable_store_product_assorts_map = promotion
        ? promotion.discountable_store_product_assorts_map
        : {};
      let choose_gifts = []; // 可選擇贈品
      let choose_gift_qty = 0; // 可選擇贈品數量

      cartsCopy.forEach((cart) => {
        // console.debug("cartEventGroupsFormatted 1:", cart.cart_id, cart.discounted_price)
        if (discountable_store_product_assorts_map[cart.store_assort_id]) {
          // 活動價
          cart.discounted_price =
            discountable_store_product_assorts_map[cart.store_assort_id].discounted_price;
          // 活動贈品
          if (
            discountable_store_product_assorts_map[cart.store_assort_id]?.activate_gift
          ) {
            cart.gift_items =
              discountable_store_product_assorts_map[cart.store_assort_id].gift_items;
          }
        }

        // console.debug("cartEventGroupsFormatted 2:", cart.cart_id, cart.discounted_price)
        if (cart.checked) {
          assort_count += cart.quantity;
          assort_org_total += cart.sale_price * cart.quantity;
          assort_org_total2 += (cart.comm_price || cart.sale_price) * cart.quantity;
          assort_total += cart.discounted_price * cart.quantity;
        }
      });
      assort_discount = assort_org_total - assort_total;
      assort_discount2 = assort_org_total2 - assort_total;

      if (promotion) {
        let prom_discount_info = getPromotionDiscount(
          promotion,
          assort_total,
          assort_count
        );
        if (isBundlePromotionType(promotion?.type)) {
          prom_discount_info = getBundleDiscount(promotion, cartsCopy);
        }
        prom_discount = prom_discount_info.prom_discount;
        choose_gifts = prom_discount_info.choose_gifts;
        choose_gift_qty = prom_discount_info.choose_gift_qty;
      }
      /*
      console.log('===============================')
      console.log('cart_group_name: ', cart_group_name)
      console.log('assort_count: ', assort_count)
      console.log('assort_org_total: ', assort_org_total)
      console.log('assort_total: ', assort_total)
      console.log('assort_discount: ', assort_discount)
      console.log('prom_discount: ', prom_discount)
      console.log('===============================')
      */

      rst[key] = {
        cart_group_key: key,
        cart_group_name: cart_group_name,
        items: cartsCopy,
        count: assort_count,
        assort_org_total: assort_org_total,
        assort_org_total2: assort_org_total2,
        assort_total: assort_total,
        assort_discount: assort_discount,
        assort_discount2: assort_discount2,
        prom_discount: prom_discount,
        prom_id: promotion ? promotion.id : null,
        choose_gifts: choose_gifts,
        choose_gift_qty: choose_gift_qty,
      };

      return rst;
    },
    {}
  );

  end = new Date().getTime();
  // console.debug("計算 活動: " + (end - start) / 1000 + " sec")
  // handleGroupsFormatted()

  return formatted;
});

const proviceMap = computed(() => {
  if (form.country) {
    return state.countryMap?.province || {};
  }
  return {};
});

const cartGroupsFormatted = computed(() => {
  // console.warn(`computed cartGroupsFormatted ${new Date()}`);
  if (!form.carts.length) {
    return {};
  }
  var start = 0;
  var end = 0;
  start = new Date().getTime();
  // console.log("cartGroupsFormatted: ", data.value)
  const grouped = _.groupBy(form.carts, (cart) => {
    cart.cart_group = cart.sup_co_id + "#" + cart.delivery_type + "#" + cart.temperature;
    if (!cart.checked) {
      return "unchecked";
    }
    return cart.cart_group;
  });
  // console.log("by 物流: ", grouped)
  const formatted = _.reduce(
    grouped,
    (rst, val, key) => {
      const cartsCopy = _.cloneDeep(val);
      let count = 0;
      let assort_total = 0;
      let assort_org_total = 0; // 組合 sale_price 總額
      let assort_org_total2 = 0; // 組合 comm_price 總額
      let insurance_assort_org_total = 0; // 售後保障組合原始總額

      let assort_discount = 0; // 網紅折扣
      let assort_discount2 = 0; // 網紅折扣 (用 comm_price)
      let prom_discount = 0; // 活動折扣
      let promotion_event_ids = [];
      let promotion = null;

      let event_assort_map = {}; // 紀錄活動組合總金額&數量
      let min_amount_free_shipping_list = []; // 免運門檻 (順序: 活動 -> 全站，取最低金額)

      let assort_total_non_excluded_discount = 0; // 計算全站免運用（要檢查 is_excluded_discount ）
      let delivery_fees_discount = 0; // 運費折扣
      let delivery_outer_island_fees_discount = 0; // 運費折扣 (外島)
      let amount_become_free_shipping = 0; // 還差多少金額免運

      cartsCopy.forEach((cart) => {
        if (
          cart.event_group &&
          !promotion_event_ids.includes(cart.event_group.event_id)
        ) {
          promotion_event_ids.push(cart.event_group.event_id);
          promotion = promotionMap.value[cart.event_group.event_id];
          // console.debug("promotion:", promotion?.is_excluded_outer_island_free_shipping)
        }
        let discountable_store_product_assorts_map = promotion
          ? promotion.discountable_store_product_assorts_map
          : {};
        // 活動價
        if (discountable_store_product_assorts_map[cart.store_assort_id]) {
          cart.discounted_price =
            discountable_store_product_assorts_map[cart.store_assort_id].discounted_price;
        }
        count += cart.quantity;
        assort_org_total += cart.sale_price * cart.quantity;
        assort_org_total2 += (cart.comm_price || cart.sale_price) * cart.quantity;
        assort_total += cart.discounted_price * cart.quantity;

        if (!cart.is_excluded_discount) {
          assort_total_non_excluded_discount += cart.discounted_price * cart.quantity;
          // // 先不改
          // if (promotion?.is_excluded_outer_island_free_shipping) {
          //   let delivery_type = key.split("_")[1];
          //   const isLogisticOuterIsland = state.isOuterIsland[delivery_type];
          //   if (!isLogisticOuterIsland) {
          //     assort_total_non_excluded_discount +=
          //       cart.discounted_price * cart.quantity;
          //   }
          // } else {
          //   assort_total_non_excluded_discount +=
          //     cart.discounted_price * cart.quantity;
          // }
        }
        // console.debug("cartGroupsFormatted:", cart.cart_id, cart.discounted_price)

        // 只計算非活動的商品
        if (!cart.event_group) {
          insurance_assort_org_total += cart.sale_price * cart.quantity;
        }

        if (cart.event_group && cart.event_group.event_id) {
          if (!event_assort_map[cart.event_group.event_id]) {
            event_assort_map[cart.event_group.event_id] = {
              assort_total: 0,
              count: 0,
            };
          }
          event_assort_map[cart.event_group.event_id].assort_total +=
            cart.discounted_price * cart.quantity;
          event_assort_map[cart.event_group.event_id].count += cart.quantity;
        }
      });
      assort_discount = assort_org_total - assort_total;
      assort_discount2 = assort_org_total2 - assort_total;

      if (promotion_event_ids.length) {
        promotion_event_ids.forEach((event_id) => {
          let event_assort_total = event_assort_map[event_id]
            ? event_assort_map[event_id].assort_total
            : 0;
          let event_count = event_assort_map[event_id]
            ? event_assort_map[event_id].count
            : 0;
          let promotion = promotionMap.value?.[event_id];
          if (promotion) {
            let prom_discount_info = getPromotionDiscount(
              promotion,
              event_assort_total,
              event_count
            );
            if (isBundlePromotionType(promotion?.type)) {
              prom_discount_info = getBundleDiscount(promotion, cartsCopy);
            }
            prom_discount += prom_discount_info.prom_discount;
            let event_total = event_assort_total - prom_discount_info.prom_discount;

            if (
              promotion.min_amount_free_shipping &&
              promotion.min_amount_free_shipping !== null
              // && event_total >= promotion.min_amount_free_shipping
            ) {
              min_amount_free_shipping_list.push(promotion.min_amount_free_shipping);
            }
          }
        });
      }

      // if (
      //   data.value.free_delivery_amount_limit &&
      //   data.value.free_delivery_amount_limit !== null
      // ) {
      //   min_amount_free_shipping_list.push(
      //     data.value.free_delivery_amount_limit
      //   );
      // }

      let min_amount_free_shipping = null;
      if (min_amount_free_shipping_list.length > 0) {
        min_amount_free_shipping = Math.min(...min_amount_free_shipping_list);
      }

      let cart = cartsCopy[0];
      let cart_group_name = null;
      if (cart.delivery_type) {
        cart_group_name =
          cart.sup_co_name +
          "。" +
          logisticMap.value[cart.delivery_type].name +
          "。" +
          TEMPERATURE_I18N.value[cart.temperature];
      }

      // 售後保障費
      const insurance_fees = formatFloat(
        insurance_assort_org_total * 0.1,
        data.value.currency_point
      );

      // console.debug("cartGroupsFormatted: ", cart)
      // console.debug("promotion:", promotion?.is_excluded_outer_island_free_shipping)
      // console.debug("min_amount_free_shipping:", assort_total, min_amount_free_shipping)
      if (promDiscount.value) {
        // 全站免運門檻還要再扣掉“活動折扣”
        assort_total_non_excluded_discount -= promDiscount.value;
        if (assort_total_non_excluded_discount < 0) {
          assort_total_non_excluded_discount = 0;
        }
      }

      // console.warn("min_amount_free_shipping", min_amount_free_shipping);
      // console.warn("assort_total", assort_total);
      // console.warn("free_delivery_amount_limit", data.value.free_delivery_amount_limit);
      // console.warn("assort_total_non_excluded_discount", assort_total_non_excluded_discount);
      if (
        (min_amount_free_shipping !== null) &
        (assort_total - promDiscount.value >= min_amount_free_shipping)
      ) {
        delivery_fees_discount = calcDeliveryFees(cart.delivery_type);
      } else {
        // 全站免運（檢查不適用其他折扣）
        if (
          data.value.free_delivery_amount_limit &&
          data.value.free_delivery_amount_limit !== null &&
          assort_total_non_excluded_discount >= data.value.free_delivery_amount_limit
        ) {
          delivery_fees_discount = calcDeliveryFees(cart.delivery_type);
        }
      }

      if (
        !promotion?.is_excluded_outer_island_free_shipping &&
        (min_amount_free_shipping !== null) & (assort_total >= min_amount_free_shipping)
      ) {
        delivery_outer_island_fees_discount = calcDeliveryOutIslandFees(
          cart.delivery_type
        );
      } else {
        // 全站免運（檢查不適用其他折扣）
        if (
          data.value.free_delivery_amount_limit &&
          data.value.free_delivery_amount_limit !== null &&
          assort_total_non_excluded_discount >= data.value.free_delivery_amount_limit
        ) {
          delivery_outer_island_fees_discount = calcDeliveryOutIslandFees(
            cart.delivery_type
          );
        }
      }

      // 還差多少免運
      if (!delivery_fees_discount) {
        if (
          (min_amount_free_shipping !== null) &
          (assort_total - promDiscount.value < min_amount_free_shipping)
        ) {
          amount_become_free_shipping =
            min_amount_free_shipping - assort_total + promDiscount.value;
        }
        if (!amount_become_free_shipping) {
          if (
            data.value.free_delivery_amount_limit &&
            data.value.free_delivery_amount_limit !== null &&
            assort_total_non_excluded_discount < data.value.free_delivery_amount_limit
          ) {
            amount_become_free_shipping =
              data.value.free_delivery_amount_limit - assort_total_non_excluded_discount;
          }
        }
      }
      console.debug("免運門檻 amount_become_free_shipping", amount_become_free_shipping);

      rst[key] = {
        cart_group_key: key,
        cart_group_name: cart_group_name,
        sup_co_id: cart.sup_co_id,
        delivery_type: cart.delivery_type,
        temperature: cart.temperature,
        items: cartsCopy,
        count: count,
        assort_total: assort_total,

        assort_org_total: assort_org_total,
        assort_org_total2: assort_org_total2,
        assort_discount: assort_discount,
        assort_discount2: assort_discount2,
        prom_discount: prom_discount,

        delivery_fees: calcDeliveryFees(cart.delivery_type),
        delivery_fees_discount: delivery_fees_discount,
        amount_become_free_shipping, // 還差多少金額免運

        delivery_outer_island_fees: calcDeliveryOutIslandFees(cart.delivery_type),
        delivery_outer_island_fees_discount: delivery_outer_island_fees_discount,
        // delivery_outer_island_fees_discount:
        //   !promotion?.is_excluded_outer_island_free_shipping &&
        //   (min_amount_free_shipping !== null) &
        //     (assort_total >= min_amount_free_shipping)
        //     ? calcDeliveryOutIslandFees(cart.delivery_type)
        //     : 0,
        insurance_assort_org_total: insurance_assort_org_total,
        insurance_fees: insurance_fees,
      };
      return rst;
    },
    {}
  );

  end = new Date().getTime();
  // console.debug("計算 物流: " + (end - start) / 1000 + " sec")

  return formatted;
});
// 網紅折扣
const assortDiscount = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartEventGroupsFormatted.value)) {
    total += v.assort_discount;
  }
  return formatFloat(total, data.value.currency_point);
});
// 網紅折扣 (用 comm_price)
const assortDiscount2 = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartEventGroupsFormatted.value)) {
    total += v.assort_discount2;
  }
  return formatFloat(total, data.value.currency_point);
});
// 活動折扣
const promDiscount = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartEventGroupsFormatted.value)) {
    // console.warn('promDiscount', v?.cart_group_name, v.prom_discount)
    total += v.prom_discount;
  }
  return formatFloat(total, data.value.currency_point);
});
// 運費
const deliveryFees = computed(() => {
  // 偵測重算運費/總價用
  const refreshPriceId = refreshPricingVersion.value;
  if (!refreshPriceId) {
    return;
  }
  // console.warn(`computed deliveryFees ${refreshPriceId}`);
  let total = 0;
  for (const [k, v] of Object.entries(cartGroupsFormatted.value)) {
    // delivery_outer_island_fees
    if (v.cart_group_key !== "unchecked") {
      // console.warn("運費:", v.delivery_type, state.isOuterIsland);
      if (state.isOuterIsland[v.delivery_type]) {
        total += v.delivery_outer_island_fees;
      } else {
        total += v.delivery_fees;
      }
    }
  }
  return formatFloat(total, data.value.currency_point);
});
// 運費折扣
const deliveryFeesDiscount = computed(() => {
  // 偵測重算運費/總價用
  const refreshPriceId = refreshPricingVersion.value;
  if (!refreshPriceId) {
    return;
  }
  // console.warn(`computed deliveryFeesDiscount ${refreshPriceId}`);
  let total = 0;
  for (const [k, v] of Object.entries(cartGroupsFormatted.value)) {
    if (v.cart_group_key !== "unchecked") {
      if (state.isOuterIsland[v.delivery_type]) {
        total += v.delivery_outer_island_fees_discount;
      } else {
        total += v.delivery_fees_discount;
      }
      // console.debug("運費折扣:", v)
    }
  }
  // console.warn(`computed deliveryFeesDiscount ${new Date()}`, total);
  return formatFloat(total, data.value.currency_point);
});

const promotionCodeDiscount = computed(() => {
  // 活動贈品不能使用購物金＆折扣碼
  if (hasPromGift.value) {
    return 0;
  }
  return state.discountCode && state.discountCode?.isAllowUse
    ? state.discountCode.amount
    : 0;
});
// 品質保障費的原始商品總額
const insuranceAssortRawTotal = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartGroupsFormatted.value)) {
    if (v.cart_group_key !== "unchecked") {
      total += v.insurance_assort_org_total;
    }
  }
  return formatFloat(total, data.value.currency_point);
});
// 品質保障費
const insuranceFees = computed(() => {
  let total = 0;
  for (const [k, v] of Object.entries(cartGroupsFormatted.value)) {
    // console.log("cart_group_key: ", v.cart_group_key, v.insurance_fees)
    if (v.cart_group_key !== "unchecked") {
      total += v.insurance_fees;
    }
  }
  // console.log("insuranceFees: ", total)
  return formatFloat(total, data.value.currency_point);
});

const usedLogisticTypes = computed(() => {
  const delivery_types = [];
  // console.log("cartGroupsFormatted: ", cartGroupsFormatted.value)
  for (const [k, v] of Object.entries(cartGroupsFormatted.value)) {
    if (v.cart_group_key !== "unchecked") {
      delivery_types.push(v.delivery_type);
    }
  }
  return delivery_types;
});

const enableEInvoice = computed(() => {
  // console.log("invoice_type", state.invoice_type)
  if (state.invoice_type == "ELECTRONIC") {
    return true;
  }
  return false;
});

const availablePaymentTypes = computed(() => {
  if (!data.value) {
    return [];
  }
  let payments = data.value.payments.filter(
    (payment) => !["ECPAY.CREDIT_PERIOD"].includes(payment.type)
  )
  // 排除沒有可用物流的超商取貨付款 PERSONALLY.COD / C2CUNIMART.COD / C2CFAMI.COD / C2CHILIFE.COD
  const isHasHome = data.value.logistics.some((logistic) => ['HOME', 'SELF'].includes(logistic.delivery_type));
  if (!isHasHome) {
    payments = payments.filter((payment) => !["PERSONALLY.COD"].includes(payment.type));
  }
  const isHasCvsUnimart = data.value.logistics.some((logistic) => logistic.delivery_type === "CVS_UNIMART");
  if (!isHasCvsUnimart) {
    payments = payments.filter((payment) => !["C2CUNIMART.COD"].includes(payment.type));
  }
  const isHasCvsFami = data.value.logistics.some((logistic) => logistic.delivery_type === "CVS_FAMI");
  if (!isHasCvsFami) {
    payments = payments.filter((payment) => !["C2CFAMI.COD"].includes(payment.type));
  }
  const isHasCvsHilife = data.value.logistics.some((logistic) => logistic.delivery_type === "CVS_HILIFE");
  if (!isHasCvsHilife) {
    payments = payments.filter((payment) => !["C2CHILIFE.COD"].includes(payment.type));
  }
  const isHasCvsOkmart = data.value.logistics.some((logistic) => logistic.delivery_type === "CVS_OKMART");
  if (!isHasCvsOkmart) {
    payments = payments.filter((payment) => !["C2COKMART.COD"].includes(payment.type));
  }
  return payments;
});

const availableLogisticTypes = computed(() => {
  if (!data.value) {
    return [];
  }
  // 如果金流選了 (.+).COD 貨到付款（disabled其他物流）
  let selectedPaymentType = form.payment_type;
  if (selectedPaymentType === 'ECPAY.CreditInstallment') {
    selectedPaymentType = 'ECPAY';
  }
  if (selectedPaymentType && selectedPaymentType?.substr(-4) === ".COD") {
    const paymentCodLogisticType = selectedPaymentType.slice(0, -4);
    let matchedCODDeliveryType = paymentCodLogisticType;
    if (["PERSONALLY", "TCAT"].includes(paymentCodLogisticType)) {
      matchedCODDeliveryType = "HOME";
    } else if (["C2CUNIMART", "B2CUNIMART"].includes(paymentCodLogisticType)) {
      matchedCODDeliveryType = "CVS_UNIMART";
    } else if (["C2CFAMI", "B2CFAMI"].includes(paymentCodLogisticType)) {
      matchedCODDeliveryType = "CVS_FAMI";
    } else if (["C2CHILIFE", "B2CHILIFE"].includes(paymentCodLogisticType)) {
      matchedCODDeliveryType = "CVS_HILIFE";
    } else if (["C2COKMART", "B2COKMART"].includes(paymentCodLogisticType)) {
      matchedCODDeliveryType = "CVS_OKMART";
    }
    return data.value.logistics.map((logistic) => ({
      ...logistic,
      disabled: logistic.delivery_type !== matchedCODDeliveryType,
    }));
  }
  return data.value.logistics.map((logistic) => ({
    ...logistic,
    disabled: false,
  }));
});

const ruleFormRef = ref();

const form = reactive({
  // 購買者
  buyer_name: null,
  buyer_mobile: null,
  buyer_email: null,
  // 收件者
  uads_id: 0,
  to_name: null,
  to_mobile: null,
  to_email: null,
  country: null,
  province: null,
  city: null,
  region: null,
  postal_code: null,
  address: null,
  // 金流
  payment_type: availablePaymentTypes.value.length
    ? availablePaymentTypes.value[0].type
    : null,
  // 寄送方式
  delivery_type: availableLogisticTypes.value.length
    ? availableLogisticTypes.value[0].delivery_type
    : null,
  // 發票
  invoice_print_mark: "N",
  invoice_type: "invoice",
  invoice_relation_option: "ORDER",
  invoice_relation_value: null,
  invoice_paper_no: null,
  invoice_paper_title: null,
  invoice_paper_relation_mobile: null,
  invoice_donate_code: "168001",
  invoice_province: null,
  invoice_city: null,
  invoice_region: null,
  invoice_postal_code: null,
  invoice_address: null,
  // 購物金
  shop_coin_discount: 0,
  memo: null,
  cvs_711_shop_id: null,
  cvs_711_shop_form: {
    province: null,
    distinct: null,
    road: null,
  },
  cvs_family_shop_id: null,
  cvs_family_shop_form: {
    province: null,
    distinct: null,
    road: null,
  },
  cvs_hilife_shop_id: null,
  cvs_hilife_shop_form: {
    province: null,
    distinct: null,
    road: null,
  },
  cvs_okmart_shop_id: null,
  cvs_okmart_shop_form: {
    province: null,
    distinct: null,
    road: null,
  },
  uads_address: true,
  uads_cvs_pcsc: true,
  uads_cvs_family: true,
  uads_cvs_hilife: true,
  uads_cvs_okmart: true,
  prom_code_id: null,
  carts: [],
  showToInfo: false,
});

const rules = reactive({
  buyer_name: [
    {
      required: true,
      message: t("errors.pleaseInput", [t("orders.buyerName")]),
      trigger: "blur",
    },
  ],
  buyer_mobile: [
    {
      required: true,
      message: t("errors.pleaseInput", [t("orders.buyerPhone")]),
      trigger: "blur",
    },
  ],
  buyer_email: [
    {
      type: "email",
      message: t("請檢查您輸入的E-mail格式是否正確"),
      trigger: ["blur", "change"],
    },
  ],
  to_name: [
    {
      required: true,
      message: t("errors.pleaseInput", [t("orders.toName")]),
      trigger: "blur",
    },
  ],
  to_mobile: [
    {
      required: true,
      message: t("errors.pleaseInput", [t("orders.toPhone")]),
      trigger: "blur",
    },
  ],
  province: [
    {
      required: true,
      message: t("errors.pleaseSelect", [t("users.province")]),
      trigger: "change",
    },
  ],
  city: [
    {
      required: true,
      message: t("errors.pleaseSelect", [t("users.city")]),
      trigger: "change",
    },
  ],
  region: [
    {
      required: true,
      message: t("errors.pleaseSelect", [t("users.region")]),
      trigger: "change",
    },
  ],
  postal_code: [
    {
      required: true,
      message: t("errors.pleaseInput", [t("users.postcode")]),
      trigger: "blur",
    },
  ],
  address: [
    {
      required: true,
      message: t("errors.pleaseInput", [t("orders.toAddress")]),
      trigger: "blur",
    },
  ],
  cvs_711_shop_form: {
    province: [
      {
        required: true,
        message: t("errors.pleaseSelect", [t("users.province")]),
        trigger: "change",
      },
    ],
    distinct: [
      {
        required: true,
        message: t("errors.pleaseSelect", [t("users.city")]),
        trigger: "change",
      },
    ],
    road: [
      {
        required: true,
        message: t("errors.pleaseSelect", [t("users.road")]),
        trigger: "change",
      },
    ],
  },

  cvs_711_shop_id: [
    {
      required: true,
      message: t("errors.pleaseSelect", [t("orders.mart")]),
      trigger: "change",
    },
  ],
  cvs_family_shop_form: {
    province: [
      {
        required: true,
        message: t("errors.pleaseSelect", [t("users.province")]),
        trigger: "change",
      },
    ],
    distinct: [
      {
        required: true,
        message: t("errors.pleaseSelect", [t("users.city")]),
        trigger: "change",
      },
    ],
    road: [
      {
        required: true,
        message: t("errors.pleaseSelect", [t("users.road")]),
        trigger: "change",
      },
    ],
  },
  cvs_family_shop_id: [
    {
      required: true,
      message: t("errors.pleaseSelect", [t("orders.mart")]),
      trigger: "change",
    },
  ],
  cvs_hilife_shop_form: {
    province: [
      {
        required: true,
        message: t("errors.pleaseSelect", [t("users.province")]),
        trigger: "change",
      },
    ],
    distinct: [
      {
        required: true,
        message: t("errors.pleaseSelect", [t("users.city")]),
        trigger: "change",
      },
    ],
    road: [
      {
        required: true,
        message: t("errors.pleaseSelect", [t("users.road")]),
        trigger: "change",
      },
    ],
  },
  cvs_hilife_shop_id: [
    {
      required: true,
      message: t("errors.pleaseSelect", [t("orders.mart")]),
      trigger: "change",
    },
  ],
  cvs_okmart_shop_form: {
    province: [
      {
        required: true,
        message: t("errors.pleaseSelect", [t("users.province")]),
        trigger: "change",
      },
    ],
    distinct: [
      {
        required: true,
        message: t("errors.pleaseSelect", [t("users.city")]),
        trigger: "change",
      },
    ],
    road: [
      {
        required: true,
        message: t("errors.pleaseSelect", [t("users.road")]),
        trigger: "change",
      },
    ],
  },
  cvs_okmart_shop_id: [
    {
      required: true,
      message: t("errors.pleaseSelect", [t("orders.mart")]),
      trigger: "change",
    },
  ],
  invoice_type: [
    {
      required: true,
      message: t("errors.pleaseSelect", [t("invoices.type")]),
      trigger: "change",
    },
  ],
  invoice_paper_no: [
    {
      required: true,
      message: t("errors.pleaseInput", [t("invoices.uniformNumbers")]),
      trigger: "blur",
    },
  ],
  invoice_paper_title: [
    {
      required: true,
      message: t("errors.pleaseInput", [t("invoices.companyName")]),
      trigger: "blur",
    },
  ],
  // invoice_paper_relation_mobile: [
  //   {
  //     required: true,
  //     message: t("errors.pleaseInput", [
  //       t("invoices.mobile"),
  //     ]),
  //     trigger: "blur",
  //   },
  // ],
  invoice_relation_value: [
    {
      required: true,
      message: t("errors.pleaseInput", [t("invoices.carrierCode")]),
      trigger: "blur",
    },
  ],
  invoice_province: [
    {
      required: true,
      message: t("errors.pleaseSelect", [t("users.province")]),
      trigger: "change",
    },
  ],
  invoice_city: [
    {
      required: true,
      message: t("errors.pleaseSelect", [t("users.city")]),
      trigger: "change",
    },
  ],
  invoice_region: [
    {
      required: true,
      message: t("errors.pleaseSelect", [t("users.region")]),
      trigger: "change",
    },
  ],
  invoice_postal_code: [
    {
      required: true,
      message: t("errors.pleaseInput", [t("users.postcode")]),
      trigger: "blur",
    },
  ],
  invoice_address: [
    {
      required: true,
      message: t("errors.pleaseInput", [t("orders.toAddress")]),
      trigger: "blur",
    },
  ],
  invoice_donate_code: [
    {
      required: true,
      message: t("errors.pleaseSelect", [t("invoices.donateXCA")]),
      trigger: "blur",
    },
  ],
});

const state = reactive({
  visible: false,
  check_all: true,
  isIndeterminate: false,
  isOuterIsland: {},
  sameHome: true,

  // show: true,
  lang: "zh-tw",
  currency: null,
  currency_symbol: null,
  currency_point: 0,
  checkout_amount_limit: null,
  free_delivery_amount_limit: null,
  enable_insurance_fees: false,
  invoice_type: "invoice",
  countryMap: null,
  discountCode: null,
  // 711門市
  cvs_711_provinces: [],
  cvs_711_distincts: [],
  cvs_711_roads: [],
  cvs_711_shops: [],

  // 全家門市
  cvs_family_provinces: [],
  cvs_family_distincts: [],
  cvs_family_roads: [],
  cvs_family_shops: [],

  // 萊爾富門市
  cvs_hilife_provinces: [],
  cvs_hilife_distincts: [],
  cvs_hilife_roads: [],
  cvs_hilife_shops: [],

  // OK門市門市
  cvs_okmart_provinces: [],
  cvs_okmart_distincts: [],
  cvs_okmart_roads: [],
  cvs_okmart_shops: [],

  invoiceDonateOptions: [
    { label: "(168001) 財團法人ＯＭＧ關懷社會愛心基金會", value: "168001" },
    { label: "(1577) 社團法人中華民國自閉症總會", value: "1577" },
    { label: "(6274) 中華民國災難救援協會", value: "6274" },
  ],
  logistics: [],
  storeId: null,
  refStoreId: null,
  trackingData: {},
  refStoreMap: {},
  isCartEditing: false,
  fromBuyNow: false,
  storeAddOns: [],
  storeAddOnParamChecksum: null,
});

const handleSameHome = (val) => {
  // console.debug("handleSameHome", val);
  state.sameHome = val;
};

const calcDeliveryFees = (delivery_type) => {
  // console.debug("calcDeliveryFees", delivery_type);
  if (!delivery_type) {
    return 0;
  }
  // console.log("calcDeliveryFees: ", delivery_type)
  const logistic = logisticMap.value[delivery_type];
  return logistic._fee_amount;
};

const calcDeliveryOutIslandFees = (delivery_type) => {
  // console.debug("calcDeliveryOutIslandFees", delivery_type);
  if (!delivery_type) {
    return 0;
  }
  const logistic = logisticMap.value[delivery_type];
  if (!logistic) {
    return 0;
  }
  const rate = logistic.rates.find((rate) => rate.countries.includes(form?.country));
  // console.debug("calcDeliveryOutIslandFees: ", delivery_type, rate)
  if (rate?.fees.length) {
    const fee = rate?.fees[0];
    if (fee?.is_open_outer_island) {
      return fee?.outer_island_fee_amount || 0;
    }
  }
  return 0;
};

// 變更組合
const handleChangeAssort = async (item) => {
  try {
    if (!item?.cart_id) {
      return;
    }
    // 檢查現有購物車是否已有此組合
    const cart = form.carts.find(
      (el) =>
        el?.store_product_id === item?.store_product_id &&
        el?.store_assort_id === item?.new_store_assort_id
    );

    // 刪除原先的 cart_id
    await deleteCart(item.cart_id);

    if (cart) {
      // 更新購物車數量

      let quantity = item.quantity + cart.quantity;
      if (quantity > item?.max_order_quantity) {
        quantity = item?.max_order_quantity;
      } else if (quantity < item?.min_order_quantity) {
        quantity = item?.min_order_quantity;
      }
      const payload = {
        cartId: cart.cart_id,
        qty: quantity,
        isBundle: props.isBundle,
      };
      await changeQty(payload);
    } else {
      // 加入購物車
      await addToCartByPayload({ ...item, isBundle: props.isBundle });
    }
  } catch (error) {
    notificationErrors(error);
  }
};

const addToCartByPayload = async (item, redirect = false) => {
  // console.debug("addToCartByPayload", item)

  try {
    const { res, payload } = await store.dispatch("lite/addToCart", item);
    const storageName = item?.event_id ? "ADD_TO_CART_GROUP" : "ADD_TO_CART";

    localStorage.removeItem(storageName);
    const eventID = res?.headers?.["x-request-id"]
      ? cartData.value?.headers?.["x-request-id"]
      : null;
    aibTrackers.addToCart(payload, null, eventID);
    gtmTrackers.addToCart(payload, null, eventID);
    fbqTrackers.addToCart(payload, null, eventID);
    ttqTrackers.addToCart(payload, null, eventID);
    gtagTrackers.addToCart(payload, null, eventID);

    // updateCart();
  } catch (err) {
    // console.error("加入購物車失敗: ", payload)
    if (err?.errors) {
      const { type, msg } = err.errors[0];
      if (type == "RequireLoginError") {
        const temp = { payload: payload, redirect: redirect };
        localStorage.setItem(storageName, JSON.stringify(temp));
      } else {
        localStorage.removeItem(storageName);
      }
    }
    notificationErrors(err);
  } finally {
    store.dispatch("lite/setFullPageLoading", false);
  }
};

const deleteCart = async (cartId) => {
  try {
    // console.debug("deleteCart", cartId);
    const deleteCartResp = await store.dispatch("lite/deleteCart", cartId);
    const idx = form.carts.findIndex((el) => el.cart_id === cartId);
    const deletedCart = form.carts[idx] || {};

    // tracking event RemoveFromCart
    const deletedCartPromotionData =
      promotionMap.value?.[deletedCart?.event_group?.event_id] || {};
    const storeProductAssortFullName = `${deletedCart.product_name || "NO_NAME"} - ${deletedCart.assort_name || "NO_ASSORT_NAME"
      }`;
    const storeProductAssortPrice = deletedCart.sale_price || 0;
    const removeFromCartData = {
      currency: state.currency || "TWD",
      value: storeProductAssortPrice,
      items: [
        {
          id: `${deletedCart.store_product_id}`,
          name: storeProductAssortFullName,
          item_id: `${deletedCart.store_product_id}`,
          item_name: storeProductAssortFullName,
          price: storeProductAssortPrice,
          quantity: deletedCart.quantity,
        },
      ],
      contents: [
        {
          id: `${deletedCart.store_product_id}`,
          name: storeProductAssortFullName,
          content_id: `${deletedCart.store_product_id}`,
          content_name: storeProductAssortFullName,
          price: storeProductAssortPrice,
          quantity: deletedCart.quantity,
        },
      ],
      content_type: "product",
      content_name: storeProductAssortFullName,
    };
    // eventID 從 header x-request-id 讀取
    let eventID = deleteCartResp?.headers?.["x-request-id"]
      ? deleteCartResp.headers["x-request-id"]
      : null;
    // AIB Tracking
    aibTrackers.createEvent(
      "RemoveFromCart",
      _.merge(aibTrackers.defaultParams, {
        custom_data: {
          content_type: "product",
          contents: removeFromCartData.contents,
          currency: state.currency || "TWD",
          items: [
            {
              event_id: deletedCartPromotionData?.id,
              event_name: dataTranslations(
                deletedCartPromotionData?.title_translations || {}
              ),
              store_product_id: deletedCart.store_product_id,
              store_product_assort_id: deletedCart.store_assort_id,
              prod_name: deletedCart.product_name || "NO_NAME",
              prod_assort_name: deletedCart.assort_name || "NO_ASSORT_NAME",
              quantity: deletedCart.quantity,
              price: deletedCart.sale_price || 0,
              category: null,
            },
          ],
          value: deletedCart.sale_price || 0,
        },
      }),
      eventID
    );
    // facebook pixels
    fbqTrackers.createEvent(
      "RemoveFromCart",
      _.pickBy(removeFromCartData, (val, key) =>
        _.includes(
          [
            "contents",
            "content_ids",
            "content_name",
            "content_type",
            "currency",
            "value",
          ],
          key
        )
      ),
      eventID
    );
    // tiktok pixels
    ttqTrackers.createEvent(
      "RemoveFromCart",
      { ...ttqTrackers.fbq2ttqData(removeFromCartData) },
      eventID
    );
    // google analytics
    gtmTrackers.createEvent(
      "event",
      gtmTrackers.actions.REMOVE_FROM_CART,
      _.pickBy(removeFromCartData, (val, key) =>
        _.includes(["currency", "value", "items"], key)
      )
    );
    // google ads
    gtagTrackers.createEvent(
      "event",
      "conversion",
      _.merge(
        _.pickBy(removeFromCartData, (val, key) =>
          _.includes(["currency", "transaction_id", "value", "items"], key)
        ),
        {
          send_to: gtagTrackers.actions.REMOVE_FROM_CART,
        }
      )
    );
  } catch (error) {
    notificationErrors(error);
  } finally {
    assignCartCount(true);
    refreshPricingVersion.value = +new Date();
  }
};

const changeQty = async (payload) => {
  // console.debug("changeQty", cartId, qty);
  if (!ruleFormRef.value) {
    return;
  }
  try {
    await store.dispatch("lite/changeQty", payload);
  } catch (error) {
    notificationErrors(error);
  } finally {
    assignCartCount(true);
    refreshPricingVersion.value = +new Date();
  }
};

const setCountryMap = async (country) => {
  if (country) {
    const resp = await _api_getCountryMap(country);
    state.countryMap = resp.data;
  } else {
    state.countryMap = {};
  }
};

const errorFieldsNotificationScroll = (fields) => {
  for (const key in fields) {
    if (key.startsWith("gift_assort_")) {
      swal.fire({
        title: t("請選擇贈品"),
        type: "error",
      });
      setTimeout(() => {
        const scrollElem = document.getElementById(`${key}`);
        scrollElem &&
          scrollElem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
      }, 100);
      break;
    } else if (["buyer_mobile", "buyer_name"].includes(key)) {
      swal.fire({
        title: t("請完整填寫訂購人資訊"),
        type: "error",
      });
      setTimeout(() => {
        const scrollElem = document.getElementById("buyer_info_sector");
        scrollElem &&
          scrollElem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
      }, 100);
      break;
    } else if (["to_name", "to_mobile"].includes(key)) {
      swal.fire({
        title: t("請完整填寫收件人資訊"),
        type: "error",
      });
      setTimeout(() => {
        const scrollElem = document.getElementById("to_info_sector");
        scrollElem &&
          scrollElem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
      }, 100);
      break;
    } else if (["province", "city", "region", "postal_code", "address"].includes(key)) {
      swal.fire({
        title: t("請完整填寫收件地址"),
        type: "error",
      });
      setTimeout(() => {
        const scrollElem = document.getElementById("to_home_sector");
        scrollElem &&
          scrollElem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
      }, 100);
      break;
    } else if (
      [
        "cvs_711_shop_form.province",
        "cvs_711_shop_form.distinct",
        "cvs_711_shop_form.road",
        "cvs_711_shop_id",
      ].includes(key)
    ) {
      swal.fire({
        title: t("請選擇【7-11】取件門市"),
        type: "error",
      });
      setTimeout(() => {
        const scrollElem = document.getElementById("to_cvs_711_sector");
        scrollElem &&
          scrollElem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
      }, 500);
      break;
    } else if (
      [
        "cvs_family_shop_form.province",
        "cvs_family_shop_form.distinct",
        "cvs_family_shop_form.road",
        "cvs_family_shop_id",
      ].includes(key)
    ) {
      swal.fire({
        title: t("請選擇【全家】取件門市"),
        type: "error",
      });
      setTimeout(() => {
        const scrollElem = document.getElementById("to_cvs_family_sector");
        scrollElem &&
          scrollElem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
      }, 500);
      break;
    } else if (
      [
        "cvs_hilife_shop_form.province",
        "cvs_hilife_shop_form.distinct",
        "cvs_hilife_shop_form.road",
        "cvs_hilife_shop_id",
      ].includes(key)
    ) {
      swal.fire({
        title: t("請選擇【萊爾富】取件門市"),
        type: "error",
      });
      setTimeout(() => {
        const scrollElem = document.getElementById("to_cvs_hilife_sector");
        scrollElem &&
          scrollElem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
      }, 500);
      break;
    } else if (
      [
        "cvs_okmart_shop_form.province",
        "cvs_okmart_shop_form.distinct",
        "cvs_okmart_shop_form.road",
        "cvs_okmart_shop_id",
      ].includes(key)
    ) {
      swal.fire({
        title: t("請選擇【OK Mart】取件門市"),
        type: "error",
      });
      setTimeout(() => {
        const scrollElem = document.getElementById("to_cvs_okmart_sector");
        scrollElem &&
          scrollElem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
      }, 500);
      break;
    } else if (["shop_coin_discount"].includes(key)) {
      swal.fire({
        title: t("超出「購物金」最高可使用範圍"),
        type: "error",
      });
      setTimeout(() => {
        const scrollElem = document.getElementById("shop_coin_discount_sector");
        scrollElem &&
          scrollElem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
      }, 500);
      break;
    } else if (
      [
        "invoice_relation_value",
        "invoice_paper_no",
        "invoice_paper_title",
        "invoice_province",
        "invoice_postal_code",
        "invoice_address",
        "invoice_paper_relation_mobile",
      ].includes(key)
    ) {
      swal.fire({
        title: t("請完整輸入發票資料"),
        type: "error",
      });
      setTimeout(() => {
        const scrollElem = document.getElementById("invoice_sector");
        scrollElem &&
          scrollElem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
      }, 500);
      break;
    } else if (["buyer_email"].includes(key)) {
      swal.fire({
        title: t("請完整輸入正確的Email格式"),
        type: "error",
      });
      setTimeout(() => {
        const scrollElem = document.getElementById("buyer_info_sector");
        scrollElem &&
          scrollElem.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
      }, 500);
      break;
    } else {
      // console.log('error submit!', key)
      // console.debug("formInvalid unknown fields", fields);
      swal.fire({
        title: t("訂購資料不完整"),
        text: `${t("欄位")}: ${key}`,
        type: "error",
      });
      break;
    }
  }
};

const executeSubmit = async (formEl) => {
  if (!formEl) return;
  // console.log("executeSubmit", ruleFormRef.value)
  if (state.sameHome) {
    form.invoice_postal_code = form.postal_code;
    form.invoice_province = form.province;
    form.invoice_region = form.region;
    form.invoice_city = form.city;
    form.invoice_address = form.address;
  }
  if (!form.showToInfo) {
    form.to_name = form.buyer_name;
    form.to_mobile = form.buyer_mobile;
  }
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      const createSubmitParams = () => {
        // delete(form.cvs_711_shop_form)
        // delete(form.cvs_family_shop_form)
        let event_group_gift_items = [];
        for (const [k, v] of Object.entries(cartEventGroupsFormatted.value)) {
          v.choose_gifts.forEach((gift) => {
            gift.assorts.forEach((assort) => {
              if (assort.quantity > 0) {
                event_group_gift_items.push({
                  event_group_uuid: v.cart_group_key,
                  store_product_id: gift.id,
                  store_assort_id: assort.id,
                  quantity: assort.quantity,
                });
              }
            });
          });
        }

        // ref_store_id 變成 store_id 寫訂單
        let refStoreId = null;
        const checkedCarts = form.carts.filter((elm) => elm.checked);
        checkedCarts.map((elm) => {
          if (refStoreId === null && elm.ref_store_id) {
            refStoreId = elm.ref_store_id;
          }
        });

        // 檢查三聯式電子發票（載具）
        let invoiceType = form.invoice_type;
        let invoicePaperRelationMobile = form.invoice_paper_relation_mobile;
        let invoiceRelationOption = form.invoice_relation_option;
        let invoicePrintMark = form.invoice_print_mark;
        if (invoiceType === "invoice_paper_relation") {
          invoiceType = "invoice_paper";
          invoiceRelationOption = "ORDER";
          if (invoicePaperRelationMobile) {
            invoiceRelationOption = "MOBILE";
          }
        } else if (invoiceType === "invoice") {
          // 不使用載具，需要寄送紙本
          if (form.invoice_print_mark == "Y") {
            invoiceRelationOption = "ORDER";
            form.invoice_relation_value = null;
            form.invoice_donate_code = null;
          }
        } else if (invoiceType === "donate") {
          invoicePrintMark = "N";
        }
        if (form.invoice_print_mark == "donate") {
          // 捐贈發票
          invoiceRelationOption = "ORDER";
          invoicePrintMark == "N";
          invoiceType = "donate";
        }

        // console.debug("createSubmitParams: ", form);
        // else if (invoiceType === "invoice_paper") {
        //   invoicePaperRelationMobile = "";
        //   invoiceRelationOption = "PAPER";
        // }
        // 活動贈品不能使用購物金＆折扣碼
        if (hasPromGift.value) {
          form.shop_coin_discount = 0;
          form.prom_code_id = null;
          state.discountCode = null;
        }

        let paymentType = form.payment_type;
        let enableCreditInstallment = false;

        if (paymentType === 'ECPAY.CreditInstallment') {
          paymentType = 'ECPAY';
          enableCreditInstallment = true;
        } else {
          enableCreditInstallment = false;
        }

        return {
          ...form,
          items: checkedCarts.map((elm) => ({
            cart_id: elm.cart_id,
            quantity: elm.quantity,
            delivery_type: elm.delivery_type,
          })),
          event_group_gift_items: event_group_gift_items,
          total_price: cartTotal.value,
          store_id: state.storeId,
          ref_store_id: state.refStoreId || refStoreId,
          invoice_type: invoiceType,
          invoice_print_mark: invoicePrintMark,
          invoice_paper_relation_mobile: invoicePaperRelationMobile,
          invoice_relation_option: invoiceRelationOption,
          prom_code_id: form.prom_code_id?.id ? form.prom_code_id.id : null,
          payment_type: paymentType,
          enable_credit_installment: enableCreditInstallment,
        };
      };

      const formMap = createSubmitParams();

      // 檢查 items.length & 是否全是加購品
      if (formMap.items.length < 1) {
        swal.fire({
          title: "請勾選您要訂購之【商品】",
          type: "error",
        });
        viewCartEventItems();
        return;
      }

      // 檢查 items 是否含有主商品
      const cartMap = _.keyBy(formMap.carts, "cart_id");
      const mainProductCarts = formMap.items.filter(
        (item) =>
          cartMap?.[item.cart_id]?.ptype &&
          !["SADDT", "SGIFT"].includes(cartMap?.[item.cart_id]?.ptype)
      );

      if (mainProductCarts.length < 1) {
        swal.fire({
          title: "請勾選您要訂購之【主要商品】",
          type: "error",
        });
        viewCartEventItems();
        return;
      }

      // 檢查超商取貨付款金額是否大於 20000
      if (
        formMap.total_price > 20000 &&
        ["C2CUNIMART.COD", "C2CFAMI.COD", "C2CHILIFE.COD"].includes(formMap.payment_type)
      ) {
        swal.fire({
          title: "【超商取貨付款】每筆訂單金額上限兩萬元",
          type: "error",
        });
        setTimeout(() => {
          const scrollElem = document.getElementById("payment_sector");
          scrollElem &&
            scrollElem.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });
        }, 500);
        return;
      }

      // buyer_email 如果是""空值, 改為 null (FastAPI會誤判)
      if (formMap.buyer_email === "") {
        formMap.buyer_email = null;
      }

      store.dispatch("lite/setFullPageLoading", true);

      // 如果有登入會員 (加入常用地址)
      if (loginUserId.value) {
        try {
          if (homeRef.value) {
            if (
              homeRef.value?.addressRef &&
              usedLogisticTypes.value.map((i) => ["HOME"].includes(i)).filter((i) => i)
                .length > 0
            ) {
              // console.debug("homeRef: ", homeRef.value?.isCreate, homeRef.value.uadsState)
              if (homeRef.value?.isCreate) {
                const uadsCreateResult = await homeRef.value.addressRef.handleCreate({
                  ...formMap,
                  countryMap: state.countryMap,
                });
                uadsCreateResult &&
                  (await homeRef.value?.addressRef.handleDefault(
                    uadsCreateResult.uads_id
                  ));
              } else {
                await homeRef.value?.addressRef.handleDefault(
                  homeRef.value?.uadsState.uads_id
                );
              }
            }
          }

          if (cvsPcscRef.value) {
            if (
              cvsPcscRef.value?.addressRef &&
              usedLogisticTypes.value
                .map((i) => ["CVS_UNIMART"].includes(i))
                .filter((i) => i).length > 0
            ) {
              // console.warn("cvsPcscRef: ", cvsPcscRef.value?.isCreate, cvsPcscRef.value.uadsState)
              if (cvsPcscRef.value?.isCreate) {
                const uadsCreateResult = await cvsPcscRef.value.addressRef.handleCreate(
                  formMap
                );
                uadsCreateResult &&
                  (await cvsPcscRef.value.addressRef.handleDefault(
                    uadsCreateResult.uads_id
                  ));
              } else {
                await cvsPcscRef.value.addressRef.handleDefault(
                  cvsPcscRef.value.uadsState.uads_id
                );
              }
            }
          }

          if (cvsFamilyRef.value) {
            if (
              cvsFamilyRef.value?.addressRef &&
              usedLogisticTypes.value
                .map((i) => ["CVS_FAMI"].includes(i))
                .filter((i) => i).length > 0
            ) {
              // console.debug("cvsFamilyRef: ", cvsFamilyRef.value?.isCreate, cvsFamilyRef.value.uadsState)
              if (cvsFamilyRef.value?.isCreate) {
                const uadsCreateResult = await cvsFamilyRef.value.addressRef.handleCreate(
                  formMap
                );
                uadsCreateResult &&
                  (await cvsFamilyRef.value.addressRef.handleDefault(
                    uadsCreateResult.uads_id
                  ));
              } else {
                await cvsFamilyRef.value.addressRef.handleDefault(
                  cvsFamilyRef.value.uadsState.uads_id
                );
              }
            }
          }

          if (cvsHilifeRef.value) {
            if (
              cvsHilifeRef.value?.addressRef &&
              usedLogisticTypes.value
                .map((i) => ["CVS_HILIFE"].includes(i))
                .filter((i) => i).length > 0
            ) {
              if (cvsHilifeRef.value?.isCreate) {
                const uadsCreateResult = await cvsHilifeRef.value.addressRef.handleCreate(
                  formMap
                );
                uadsCreateResult &&
                  (await cvsHilifeRef.value.addressRef.handleDefault(
                    uadsCreateResult.uads_id
                  ));
              } else {
                await cvsHilifeRef.value.addressRef.handleDefault(
                  cvsHilifeRef.value.uadsState.uads_id
                );
              }
            }
          }

          if (cvsOkmartRef.value) {
            if (
              cvsOkmartRef.value?.addressRef &&
              usedLogisticTypes.value
                .map((i) => ["CVS_OKMART"].includes(i))
                .filter((i) => i).length > 0
            ) {
              if (cvsOkmartRef.value?.isCreate) {
                const uadsCreateResult = await cvsOkmartRef.value.addressRef.handleCreate(
                  formMap
                );
                uadsCreateResult &&
                  (await cvsOkmartRef.value.addressRef.handleDefault(
                    uadsCreateResult.uads_id
                  ));
              } else {
                await cvsOkmartRef.value.addressRef.handleDefault(
                  cvsOkmartRef.value.uadsState.uads_id
                );
              }
            }
          }
        } catch (error) {
          console.error("checkout「加入常用地址」發送錯誤", error);
        }
      }

      // if (true) {
      //   console.debug("_api_checkoutCart", formMap);
      //   swal
      //     .fire({
      //       title: "DEBUG",
      //       html:
      //         `<pre style="text-align: left; font-size: 12px; max-height: 55vh; overflow: auto;">${JSON.stringify(formMap, null, 2)}</pre>`,
      //       type: "success",
      //     });
      //   store.dispatch("lite/setFullPageLoading", false);
      //   return;
      // }

      _api_checkoutCart(formMap)
        .then(async (res) => {
          if (res.status == 200) {
            // console.log("res: ", res.data)
            clearCartCount();
            // const redirect_url = res.data.redirect_url;
            // window.location.assign(redirect_url);
            const orderData = res.data;
            const {
              order_id,
              order_uuid,
              currency,
              payment_type,
              payment_url,
            } = orderData;
            let { total } = orderData;

            if (formMap.shop_coin_discount) {
              total -= formMap.shop_coin_discount;
            }

            if (payment_type.endsWith(".COD")) {
              swal
                .fire({
                  title: "下單成功！",
                  html:
                    "<div class='swal-order-info'>" +
                    `訂單編號: <b>${order_id}</b> <br />` +
                    `訂單金額: <b>${state.currency_symbol} ${currencyFormat(
                      total
                    )}</b> <br />` +
                    "</div>",
                  type: "success",
                  allowOutsideClick: false,
                })
                .then(() => {
                  store.commit("lite/resetCheckoutDialog");
                });
            } else {
              swal
                .fire({
                  title: "下單成功！",
                  html:
                    "<div class='swal-order-info'>" +
                    `訂單編號: <b>${order_id}</b> <br />` +
                    `訂單金額: <b>${state.currency_symbol} ${currencyFormat(
                      total
                    )}</b> <br />` +
                    "</div>",
                  type: "success",
                  confirmButtonText: "前往付款",
                  allowOutsideClick: false,
                })
                .then(() => {
                  store.commit("lite/resetCheckoutDialog");
                  window.open(payment_url);
                });
            }

            store.dispatch("lite/updateCart");

            // tracking event EventPurchase
            try {
              const purItems = [];
              const purContents = [];
              const purAIBTrackingItems = [];
              let purNumItems = 0;
              form.carts.forEach((cartItem) => {
                if (!cartItem.checked) {
                  return;
                }
                const purItemId = `${cartItem.store_product_id}`;
                const purItemName = `${cartItem.product_name} - ${cartItem.assort_name}`;
                const purItemPrice = cartItem.sale_price || 0;
                const purItemQty = cartItem.quantity || 0;
                purNumItems += purItemQty;
                const itemData = {
                  id: purItemId,
                  name: purItemName,
                  content_id: purItemId,
                  content_name: purItemName,
                  price: purItemPrice,
                  quantity: purItemQty,
                };
                if (cartItem?.event_group?.event_id) {
                  const purPromotionId = `PROM-${cartItem.event_group.event_id}`;
                  const purPromotionName =
                    dataTranslations(
                      promotionMap.value?.[cartItem.event_group.event_id]
                        ?.title_translations || {}
                    ) || "NO_PROM_NAME";
                  Object.assign(itemData, {
                    promotion_id: purPromotionId,
                    promotion_name: purPromotionName,
                  });
                }
                purItems.push({
                  ...itemData,
                  item_id: purItemId,
                  item_name: purItemName,
                });
                purContents.push({
                  ...itemData,
                });
                purAIBTrackingItems.push({
                  event_id: cartItem?.event_group?.event_id,
                  event_name:
                    promotionMap.value?.[cartItem?.event_group?.event_id]?.title,
                  store_product_id: cartItem?.store_product_id,
                  store_product_assort_id: cartItem?.store_assort_id,
                  prod_name: cartItem?.product_name,
                  prod_assort_name: cartItem?.assort_name,
                  quantity: purItemQty,
                  price: purItemPrice,
                  category: null,
                });
              });
              const purchaseData = {
                currency: currency || "TWD",
                value: total,
                items: purItems,
                content_type: "product",
                contents: purContents,
                num_items: purNumItems,
                transaction_id: `${order_id}`,
                transaction_uuid: `${order_uuid}`,
              };
              if (form.prom_code_id) {
                Object.assign(purchaseData, {
                  coupon: (form.prom_code_id?.promotion?.codes || []).join(""),
                });
              }
              // 用訂單 order_uuid 當 tracking -> eventID
              const eventID = `${order_uuid}`;
              // AIB Tracking
              aibTrackers.createEvent(
                "Purchase",
                _.merge(aibTrackers.defaultParams, {
                  custom_data: {
                    content_type: "product",
                    contents: purContents,
                    currency: currency || "TWD",
                    items: purAIBTrackingItems,
                    value: total,
                    order_id,
                    payment_method: payment_type,
                    delivery_method: formMap.delivery_type,
                  },
                }),
                eventID
              );
              // 如果是非會員，拿訂單【姓名】【手機號碼】【Email】丟離線轉換
              const fbqNonMemberOrderAdvancedMatching = () => {
                // 【全名】拆出【姓】、【名】
                const getFirstLastNameFromFullName = (fullName) => {
                  let firstName = "";
                  let lastName = "";
                  if (!fullName || fullName.includes("firebase-")) {
                    return [firstName, lastName];
                  }
                  fullName = fullName.trim();
                  if (fullName.includes(" ")) {
                    const parts = fullName.split(" ");
                    if (parts.length === 2) {
                      if (
                        fullName
                          .replace(" ", "")
                          .split("")
                          .every((c) => c.charCodeAt(0) > 128)
                      ) {
                        firstName = parts[1];
                        lastName = parts[0];
                      } else {
                        firstName = parts[0];
                        lastName = parts[1];
                      }
                    } else {
                      firstName = parts.slice(0, -1).join(" ");
                      lastName = parts[parts.length - 1];
                    }
                  } else {
                    if (fullName.charCodeAt(0) > 128) {
                      firstName = fullName.substring(1);
                      lastName = fullName.charAt(0);
                    } else {
                      firstName = fullName;
                      lastName = "";
                    }
                  }
                  return [firstName, lastName];
                };
                const advancedMatchingData = {
                  country: "tw",
                };
                if (formMap.buyer_email) {
                  Object.assign(advancedMatchingData, {
                    em: formMap.buyer_email.trim().toLowerCase(),
                  });
                }
                if (formMap.buyer_mobile) {
                  Object.assign(advancedMatchingData, {
                    ph: formMap.buyer_mobile.replace("+", ""),
                  });
                }
                if (formMap.buyer_name) {
                  const [firstName, lastName] = getFirstLastNameFromFullName(
                    formMap.buyer_name
                  );
                  if (firstName) {
                    Object.assign(advancedMatchingData, { fn: firstName });
                  }
                  if (lastName) {
                    Object.assign(advancedMatchingData, { ln: lastName });
                  }
                }
                if (formMap.postal_code) {
                  Object.assign(advancedMatchingData, { zp: formMap.postal_code });
                }
                // FbqTracking.changeDefaultParams.call(fbqTrackers, { ...advancedMatchingData });
                // console.warn("fbqSetUserProperties", advancedMatchingData);
                fbqTrackers.fbqSetUserProperties({ ...advancedMatchingData });
              };
              if (!loginUserId.value) {
                try {
                  fbqNonMemberOrderAdvancedMatching();
                } catch (error) {
                  console.error(`fbqNonMemberOrderAdvancedMatching`, error);
                }
              }
              // facebook pixels
              fbqTrackers.createEvent(
                "Purchase",
                _.pickBy(purchaseData, (val, key) =>
                  _.includes(
                    [
                      "content_ids",
                      "content_name",
                      "content_type",
                      "contents",
                      "currency",
                      "num_items",
                      "value",
                    ],
                    key
                  )
                ),
                eventID
              );
              // tiktok pixels
              ttqTrackers.createEvent(
                "PlaceAnOrder",
                { ...ttqTrackers.fbq2ttqData(purchaseData) },
                eventID
              );
              // google analytics
              gtmTrackers.createEvent(
                "event",
                gtmTrackers.actions.PURCHASE,
                _.pickBy(purchaseData, (val, key) =>
                  _.includes(
                    [
                      "currency",
                      "transaction_id",
                      "value",
                      "coupon",
                      "shipping",
                      "tax",
                      "items",
                    ],
                    key
                  )
                )
              );
              // google ads
              gtagTrackers.createEvent(
                "event",
                "conversion",
                _.merge(
                  _.pickBy(purchaseData, (val, key) =>
                    _.includes(["currency", "transaction_id", "value", "items"], key)
                  ),
                  {
                    send_to: gtagTrackers.actions.PURCHASE,
                  }
                )
              );
            } catch (error) {
              console.error("tracking event EventPurchase error: ", error);
            }
          } else if (res.status == 422) {
            const responseError = res?.data?.errors?.[0] || {};
            const { field: errField, msg: errMsg, type: errType } = responseError;
            if (errType === "CheckoutDataError") {
              const { invalid_type, invalid_cart_ids } = responseError;
              if (invalid_type) {
                if (invalid_cart_ids) {
                  invalid_cart_ids.forEach((cartId) => {
                    const idx = form.carts.findIndex((el) => el.cart_id === cartId);
                    const invalidCart = form.carts[idx];
                    const item_name =
                      invalidCart.product_name + " - " + invalidCart.assort_name;
                    if (invalid_type == "ITEM_DELETE") {
                      swal.fire({
                        title: t("carts.invalidItem", [item_name]),
                        type: "error",
                      });
                    } else if (invalid_type == "ITEM_LOWER") {
                      swal.fire({
                        title: t("carts.removedItem", [item_name]),
                        type: "error",
                      });
                    } else if (invalid_type == "ITEM_OUT_OF_STOCK") {
                      swal.fire({
                        title: t("carts.inventoryItem", [item_name]),
                        type: "error",
                      });
                    } else if (invalid_type == "EVENT_ITEM_DELETE") {
                      swal.fire({
                        title: "存在異常活動",
                        text: item_name,
                        type: "error",
                      });
                    } else if (invalid_type == "EVENT_ITEM_LOWER") {
                      swal.fire({
                        title: "活動已下架或尚未開始",
                        text: item_name,
                        type: "error",
                      });
                    } else {
                      swal.fire({
                        title: t("carts.abnormalItem", [item_name]),
                        type: "error",
                      });
                    }
                    // deleteCart(cartId)
                  });
                }

                if (invalid_type == "EVENT_GIFT_LOWER") {
                  swal.fire({
                    title: "贈品不存在或已下架",
                    type: "error",
                  });
                } else if (invalid_type == "EVENT_GIFT_OUT_OF_STOCK") {
                  swal.fire({
                    title: "贈品庫存不足",
                    type: "error",
                  });
                } else if (invalid_type == "EVENT_GIFT_EXCEED_QTY") {
                  swal.fire({
                    title: "已超過可選擇贈品數量",
                    type: "error",
                  });
                } else if (invalid_type == "PROM_CODE_DELETE") {
                  swal.fire({
                    title: "無法使用【折扣碼】",
                    text:
                      "請檢查是否滿足折扣碼【使用門檻】或【刪除】折扣碼後再確認訂購。",
                    type: "error",
                  });
                  setTimeout(() => {
                    const scrollElem = document.getElementsByClassName(
                      "discount-code-sector"
                    )?.[0];
                    scrollElem &&
                      scrollElem.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      });
                  }, 100);
                }
              } else {
                if (errField) {
                  errorFieldsNotificationScroll({
                    [errField]: [`${errField} form error`],
                  });
                }
                swal.fire({
                  title: t("下單失敗！"),
                  text: errMsg || t("可能系統繁忙或網路異常，請稍等一下重試看看。"),
                  type: "error",
                });
              }
            } else {
              // swal.fire(ALERT_i18n.value.input_error, 'error')
              // notificationErrors(res.data);
              console.error(`下單回傳狀態異常： ${res.status} - ${res.data}`);
              swal.fire({
                title: t("下單失敗！"),
                text: `${t("可能系統繁忙或網路異常，請稍等一下重試看看。")}`,
                footer: `${res.status} - ${JSON.stringify(res.data)}`,
                type: "error",
              });
            }
          } else {
            // swal.fire(ALERT_i18n.value.submit_error, 'error')
            // notificationErrors(res.data);
            console.error(`下單回傳狀態異常： ${res.status} - ${res.data}`);
            swal.fire({
              title: t("下單失敗！"),
              text: `${t("可能系統繁忙或網路異常，請稍等一下重試看看。")}`,
              footer: `${res.status} - ${JSON.stringify(res.data)}`,
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.error("下單失敗", error);
          swal.fire({
            title: t("下單失敗！"),
            text: `${t("可能系統繁忙或網路異常，請稍等一下重試看看。")}`,
            footer: `${error}`,
            type: "error",
          });
          // notificationErrors(error);
          // swal.fire(ALERT_i18n.value.submit_error, 'error')
        })
        .finally(() => {
          store.dispatch("lite/setFullPageLoading", false);
        });
    } else {
      // console.debug("checkout submit validation failure", fields);
      errorFieldsNotificationScroll(fields);
    }
  });
};

const initEventInitiateCheckoutOrViewCart = (
  actionEvent = "InitiateCheckout",
  eventID = null
) => {
  // tracking event `InitiateCheckout` or `ViewCart`
  if (!["InitiateCheckout", "ViewCart"].includes(actionEvent)) {
    return;
  }
  try {
    const icItems = [];
    const icContents = [];
    const icAIBTrackingItems = [];
    let icNumItems = 0;
    let refStoreId = null;
    form.carts.forEach((cartItem) => {
      // console.debug("cartItem", cartItem);
      const icItemId = `${cartItem.store_product_id}`;
      const icItemName = `${cartItem.product_name} - ${cartItem.assort_name}`;
      const icItemPrice = cartItem.sale_price || 0;
      const icItemQty = cartItem.quantity || 0;
      icNumItems += icItemQty;
      icItems.push({
        id: icItemId,
        name: icItemName,
        item_id: icItemId,
        item_name: icItemName,
        price: icItemPrice,
        quantity: icItemQty,
        // promotion_id: icPromotionId,
        // promotion_name: icPromotionName,
      });
      icContents.push({
        id: icItemId,
        name: icItemName,
        price: icItemPrice,
        quantity: icItemQty,
        content_id: icItemId,
        content_name: icItemName,
        // promotion_id: icPromotionId,
        // promotion_name: icPromotionName,
      });
      if (!refStoreId && cartItem.ref_store_id) {
        refStoreId = cartItem.ref_store_id;
      }
      icAIBTrackingItems.push({
        event_id: cartItem?.event_group?.event_id,
        event_name: promotionMap.value?.[cartItem?.event_group?.event_id]?.title,
        store_product_id: cartItem?.store_product_id,
        store_product_assort_id: cartItem?.store_assort_id,
        prod_name: cartItem?.product_name,
        prod_assort_name: cartItem?.assort_name,
        quantity: icItemQty,
        price: icItemPrice,
        category: null,
      });
    });
    const initiateCheckoutData = {
      currency: state.currency || "TWD",
      value: cartTotal.value,
      items: icItems,
      contents: icContents,
      num_items: icNumItems,
    };
    // AIB Tracking
    aibTrackers.createEvent(
      actionEvent,
      _.merge(aibTrackers.defaultParams, {
        custom_data: {
          content_type: "product",
          contents: icContents,
          currency: state.currency || "TWD",
          items: icAIBTrackingItems,
          value: cartTotal.value,
        },
      }),
      eventID
    );
    // facebook pixels
    fbqTrackers.createEvent(
      "InitiateCheckout",
      _.pickBy(initiateCheckoutData, (val, key) =>
        _.includes(
          [
            "contents",
            "content_ids",
            "currency",
            "value",
            "num_items",
            "content_category",
          ],
          key
        )
      ),
      eventID
    );
    // tiktok pixels
    ttqTrackers.createEvent(
      "InitiateCheckout",
      { ...ttqTrackers.fbq2ttqData(initiateCheckoutData) },
      eventID
    );
    // google analytics
    gtmTrackers.createEvent(
      "event",
      gtmTrackers.actions.INITIATE_CHECKOUT,
      _.pickBy(initiateCheckoutData, (val, key) =>
        _.includes(["currency", "value", "coupon", "items"], key)
      )
    );
    // google ads
    gtagTrackers.createEvent(
      "event",
      "conversion",
      _.merge(
        _.pickBy(initiateCheckoutData, (val, key) =>
          _.includes(["currency", "transaction_id", "value", "items"], key)
        ),
        {
          send_to: gtagTrackers.actions.INITIATE_CHECKOUT,
        }
      )
    );
  } catch (error) {
    console.error(`tracking event Event${actionEvent} error: `, error);
  }
};

const handleDiscountCode = (item) => {
  // console.debug("handleDiscountCode", item);
  state.discountCode = item;
};

const updateState = (newValue) => {
  // console.debug("updateState", newValue);
};

const updateData = (newValue) => {
  // console.debug("updateData", newValue);
};

const updateForm = () => {
  refreshPricingVersion.value = +new Date();
};

const updateStateIsOuterIsland = (newValue) => {
  // console.warn(`updateStateIsOuterIsland ${new Date()}`, newValue);
  state.isOuterIsland = newValue;
  // console.debug("state", state);
  // console.debug("cartGroupsFormatted.value", cartGroupsFormatted.value);
  refreshPricingVersion.value = +new Date();
};

const backToTop = () => {
  setTimeout(() => {
    const scrollElem = document.getElementsByClassName("payment-sector")?.[0];
    scrollElem &&
      scrollElem.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  }, 100);
};
const initialData = (val) => {
  if (!val?.currency) {
    return;
  }

  if (val.isPatchCartIds.length > 0) {
    // 只更新有異動的 cart_ids
    const isPatchCartIds = _.uniq(val.isPatchCartIds);
    const oldCarts = form.carts.filter((cart) => !isPatchCartIds.includes(cart.cart_id));
    const newCarts = val.carts
      .filter((cart) => isPatchCartIds.includes(cart.cart_id))
      .map((cart, carts_idx) => {
        let is_valid = false;
        if (cart.status == "shelves" && cart.quantity <= cart.max_order_quantity) {
          is_valid = true;
        }
        return {
          ...cart,
          is_valid,
          carts_idx,
          checked: is_valid,
          delivery_type: cart.available_delivery_types.includes(form.delivery_type)
            ? form.delivery_type
            : null,
        };
      });
    form.carts = [...oldCarts, ...newCarts].map((el, carts_idx) => ({
      ...el,
      carts_idx,
    }));

    refreshPricingVersion.value = +new Date();
    return;
  }

  data.value = val;
  setCountryMap(data.value.country);

  form.carts = val.carts.map((cart, carts_idx) => {
    let is_valid = false;
    if (cart.status == "shelves" && cart.quantity <= cart.max_order_quantity) {
      is_valid = true;
    }
    return {
      ...cart,
      is_valid,
      carts_idx,
      checked: is_valid,
      delivery_type: cart.available_delivery_types.includes(form.delivery_type)
        ? form.delivery_type
        : null,
    };
  });

  // console.warn("val.login_user", val.login_user);
  form.buyer_name = val.login_user.name;
  form.buyer_mobile = val.login_user.mobile;
  form.buyer_email = val.login_user.email;
  form.to_name = val.login_user.name;
  form.to_mobile = val.login_user.mobile;
  form.to_email = val.login_user.email;
  form.country = val.country;

  // // 超過兩種物流，預設強制使用預付金流
  // if (getLogisticTypess.value.length > 1 && !!prePayOpts.value.length) {
  //   form.payment_type = prePayOpts.value[0];
  // }
  state.currency = val.currency;
  state.currency_symbol = val.currency_symbol;
  state.currency_point = val.currency_point;
  state.checkout_amount_limit = val.checkout_amount_limit;
  state.free_delivery_amount_limit = val.free_delivery_amount_limit;
  state.enable_insurance_fees = val.enable_insurance_fees;
  state.invoice_type = val.invoice_type;
  state.logistics = val.logistics;

  state.storeId = storeData.value.id;
  state.refStoreId = storeData.value.parent_id || storeData.value.id;
  state.trackingData = val.trackingData;
  state.refStoreMap = val.refStoreMap;
  state.isCartEditing = val.isCartEditing;
  state.fromBuyNow = val.fromBuyNow;
  // state.storeAddOns = val.storeAddOns;
  refreshPricingVersion.value = +new Date();
  // console.debug("state", state)
};

const setCartEdited = () => {
  state.isCartEditing = false;
  state.fromBuyNow = false;
  setTimeout(() => {
    // initEventInitiateCheckoutOrViewCart('InitiateCheckout');
    const scrollElem = document.getElementsByClassName("payment-sector")?.[0];
    scrollElem &&
      scrollElem.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  }, 100);
};

const viewCartEventItems = () => {
  setTimeout(() => {
    const scrollElem = document.getElementsByClassName("product-sector")?.[0];
    scrollElem &&
      scrollElem.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  }, 100);
};

const handleClickClose = () => {
  store.commit("lite/resetCheckoutDialog");
};

watch(
  () => [form.payment_type, form.delivery_type, refreshPricingVersion.value],
  ([payment_type, delivery_type, rpVersion]) => {
    // console.warn(
    //   `watch changed payment_type=${payment_type}, delivery_type=${delivery_type}, rpVersion=${rpVersion}`
    // );
    if (!payment_type || !delivery_type || !rpVersion) {
      return;
    }
    if (payment_type === 'ECPAY.CreditInstallment') {
      payment_type = 'ECPAY';
    }
    // 設定 carts checked / invalid
    form.carts.forEach((cart) => {
      // console.log("cart: ", cart.delivery_type)
      let is_valid = true;
      let checked = true;
      // if (!cart?.checked) {
      //   checked = false;
      // }
      // 檢查上架 & 數量
      if (cart.status !== "shelves" || cart.quantity > cart.max_order_quantity) {
        checked = false;
        is_valid = false;
      }
      // 檢查外島配送
      if (state.isOuterIsland[delivery_type] && cart.is_excluded_outer_island) {
        checked = false;
        is_valid = false;
      }
      // 檢查勾選的金流是否 (可用)
      if (!cart.available_payment_types.includes(payment_type)) {
        checked = false;
        is_valid = false;
      }
      // 檢查勾選的物流是否 (可用)
      if (!cart.available_delivery_types.includes(delivery_type)) {
        checked = false;
        is_valid = false;
      } else {
        cart.delivery_type = delivery_type;
      }
      cart.checked = checked;
      cart.is_valid = is_valid;
    });
    // // 加購品
    // setStoreAddOns({ payment_type, delivery_type });
  },
  { deep: false, immediate: true }
);

watch(
  () => store.getters["lite/checkoutDialogDataUpdateAt"],
  () => {
    const { visible, data } = store.getters["lite/checkoutDialog"];
    state.visible = visible;
    if (visible) {
      // console.debug("data", data)
      initialData(data);
      initEventInitiateCheckoutOrViewCart("InitiateCheckout", data.eventID);
      if (data?.scrollToTop) {
        backToTop();
      }
    }
  },
  { deep: true, immediate: true }
);
</script>
<style lang="scss">
@import "./checkout.css";

.checkout-form-dialog {
  .el-overlay-dialog {
    overflow-y: auto;
    overflow-x: hidden;
  }

  .el-dialog {
    margin-bottom: 0;
    margin-top: 0;

    .el-dialog__title {
      font-size: 1.5rem !important;
    }
  }

  .el-dialog__body {
    margin: 0;
    padding: 0;
    height: calc(100vh - 178px);
    overflow-y: auto;
    overflow-x: hidden;
  }

  .el-dialog__header {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: white;
    border-bottom: 1px solid #ececec;
    margin-bottom: 0;
    z-index: 1;
  }

  .el-dialog__footer {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    background-color: white;
    padding: 0.5rem;
    border-top: 1px solid #ececec;
    margin-top: 0;
    z-index: 1;
    text-align: inherit;
  }

  .el-button.large-button {
    padding: 12px 30px;
    font-size: 20px;
    border-radius: 8px;
    min-height: 50px;
  }

  .checkout {
    font-size: 130%;

    // padding-bottom: 70px;
    .row {
      margin: 0;
    }

    p {
      margin-bottom: 0;
    }

    .el-form-item__label {
      font-size: 1rem;
    }

    .el-form-item__error {
      position: relative;
    }

    .checkout-footer {
      border-top: 1px solid #cdcdcd;

      .v-btn-large-text {
        font-size: 125% !important;
      }
    }

    .product-sector__content {
      scroll-margin-bottom: 100px;
    }
  }
}

.swal-order-info {
  width: fit-content;
  margin: auto;
  text-align: left;
}
</style>
